import type { ApiModuleEndpoints } from '../types'

export const salesOrderApiEndpoints = {
  orders: { method: 'GET', path: '/sales/orders', requiresAuth: true },
  createOrder: { method: 'POST', path: '/sales/orders', requiresAuth: true },
  orderDetail: { method: 'GET', path: '/sales/orders/:id', requiresAuth: true },
  updateOrder: { method: 'PUT', path: '/sales/orders/:id', requiresAuth: true },
  confirm: { method: 'POST', path: '/sales/orders/:id/confirm', requiresAuth: true },
  prepare: { method: 'POST', path: '/sales/orders/:id/prepare', requiresAuth: true },
  readyToShip: { method: 'POST', path: '/sales/orders/:id/ready-to-ship', requiresAuth: true },
  complete: { method: 'POST', path: '/sales/orders/:id/complete', requiresAuth: true },
  cancel: { method: 'POST', path: '/sales/orders/:id/cancel', requiresAuth: true },
  cancelCompleted: { method: 'POST', path: '/sales/orders/:id/cancel-completed', requiresAuth: true },
  deleteOrder: { method: 'DELETE', path: '/sales/orders/:id', requiresAuth: true },
} as const satisfies ApiModuleEndpoints
